module.exports = __webpack_public_path__ + "static/media/favorite.2cc95eab.svg";